// extracted by mini-css-extract-plugin
module.exports = {"resentCodeBtn":"confirm-email_resentCodeBtn__1xH_R"};